import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type LangsPropsType = {
  title?: string;
  [key: string]: any;
};

const LangsTransComponent = ({ title = '', ...reset }: LangsPropsType) => {
  const { t } = useTranslation();
  return <Trans i18nKey={`develop_prefix_${title}`} {...reset}></Trans>;
};

export const LangsTrans = memo(LangsTransComponent);
